<template><div><h2 id="all-sides" tabindex="-1" class="d-docsite--header-2">All Sides <a class="header-anchor d-link d-docsite--link d-link" href="#all-sides" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-baw{n}</code> to change the border width on your element.</p>
<code-example source-code='&lt;div class=&quot;d-p-200 d-ba d-baw0&quot;&gt;d-baw0&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw1&quot;&gt;d-baw1&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw2&quot;&gt;d-baw2&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw4&quot;&gt;d-baw4&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="200" :direction="{ 'default': 'column', 'md': 'row' }">
  <div class="d-p-200 d-ba d-baw0">d-baw0</div>
  <div class="d-p-200 d-ba d-baw1">d-baw1</div>
  <div class="d-p-200 d-ba d-baw2">d-baw2</div>
  <div class="d-p-200 d-ba d-baw4">d-baw4</div>
</dt-stack>
</code-example>
<h2 id="individual-sides" tabindex="-1" class="d-docsite--header-2">Individual Sides <a class="header-anchor d-link d-docsite--link d-link" href="#individual-sides" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-b{a|t|r|b|l}w{n}</code> to change the border width of your direction on your element.</p>
<code-example source-code='&lt;div class=&quot;d-p-200 d-ba d-baw0 d-bgc-primary d-btw0&quot;&gt;d-btw0&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw0 d-bgc-primary d-btw1&quot;&gt;d-btw1&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw0 d-bgc-primary d-btw2&quot;&gt;d-btw2&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-ba d-baw0 d-bgc-primary d-btw4&quot;&gt;d-btw4&lt;/div&gt;'>
<dt-stack data-demo-wrapper gap="200" :direction="{ 'default': 'column', 'md': 'row' }">
  <div class="d-p-200 d-ba d-baw0 d-bgc-primary d-btw0">d-btw0</div>
  <div class="d-p-200 d-ba d-baw0 d-bgc-primary d-btw1">d-btw1</div>
  <div class="d-p-200 d-ba d-baw0 d-bgc-primary d-btw2">d-btw2</div>
  <div class="d-p-200 d-ba d-baw0 d-bgc-primary d-btw4">d-btw4</div>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody v-for="i in ['all', 'top', 'right', 'bottom', 'left']">
      <tr v-for="(val, key) in {0: '0', 1: '100', 2: '200', 4: '300'}">
        <th scope="row" class="d-code--sm d-docsite-code">.d-b{{ i[0] }}w{{ key }}</th>
        <td class="d-code--sm">
          <span v-if="i === 'all'">border-width: var(--dt-size-border-{{ val }}) !important;</span>
          <span v-else>border-{{ i === 'top' ? 'block-start' : i === 'bottom' ? 'block-end' : i === 'left' ? 'inline-start' : i === 'right' ? 'inline-end' : i }}-width: var(--dt-size-border-{{ val }}) !important;</span>
        </td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


